import { render, staticRenderFns } from "./MyPagePanel.vue?vue&type=template&id=600881c9&scoped=true&"
import script from "./MyPagePanel.vue?vue&type=script&lang=js&"
export * from "./MyPagePanel.vue?vue&type=script&lang=js&"
import style0 from "./MyPagePanel.vue?vue&type=style&index=0&id=600881c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600881c9",
  null
  
)

export default component.exports